

export const TopProducts = [
    {
        
        id: 17,
        title: 'Rain Jacket Women Windbreaker Striped Climbing Raincoats', 
        price: 39.99, 
        description: 'Lightweight perfet for trip or casual wear---Long …djustable Drawstrings give it a real styled look.', 
        category: "women's clothing",
        image: "https://fakestoreapi.com/img/71HblAHs5xL._AC_UY879_-2.jpg",

    },
    {
        id: 15, 
        title: "BIYLACLESEN Women's 3-in-1 Snowboard Jacket Winter Coats", 
        price: 56.99, 
        description: 'Note:The Jackets is US standard size, Please choos…t season and help you adapt to different climates', 
        category: "women's clothing",
        image: "https://fakestoreapi.com/img/51Y5NI-I5jL._AC_UX679_.jpg"
    },
    {
        id: 5, 
        title: "John Hardy Women's Legends Naga Gold & Silver Dragon Station Chain Bracelet", 
        price: 695, 
        description: 'From our Legends Collection, the Naga was inspired…th love and abundance, or outward for protection.', 
        category: 'jewelery',
        image: "https://fakestoreapi.com/img/71pWzhdJNwL._AC_UL640_QL65_ML3_.jpg"
    },
    {
        id: 12, 
        title: 'WD 4TB Gaming Drive Works with Playstation 4 Portable External Hard Drive', 
        price: 114, 
        description: "Expand your PS4 gaming experience, Play anywhere F… capacity, 3-year manufacturer's limited warranty", 
        category: 'electronics',
        image: "https://fakestoreapi.com/img/61mtL65D4cL._AC_SX679_.jpg"
    }

]